import { useCallback, useSyncExternalStore } from 'react';

/**
 * La politique cookies est une **vue à part entière**, pas une section de
 * modale : elle a une URL.
 *
 * C'est ce qui permet de l'envoyer à un délégué à la protection des données, de
 * la citer dans un questionnaire de conformité ou dans un contrat de
 * sous-traitance. Une fenêtre n'a pas d'adresse ; on ne peut pas en donner le
 * lien.
 *
 * Le hash est réservé : il est intercepté avant la navigation par page du
 * viewer, donc une page du site qui porterait ce slug ne le masquerait pas.
 */
export const COOKIE_POLICY_HASH = 'politique-cookies';

export function isCookiePolicyHash(hash = '') {
  return String(hash).replace(/^#/, '') === COOKIE_POLICY_HASH;
}

export function cookiePolicyHref() {
  return `#${COOKIE_POLICY_HASH}`;
}

/**
 * La notice « Vos données » (RGPD art. 13 et 14) : qui traite les données du
 * lecteur, pourquoi, combien de temps, et comment exercer ses droits. Même
 * statut que la politique cookies — une vue réservée, avec une URL que l'e-mail
 * d'invitation donne (Proposals::ViewerSiteUrl.privacy_notice_for, dépôt web).
 */
export const PRIVACY_NOTICE_HASH = 'vos-donnees';

export function isPrivacyNoticeHash(hash = '') {
  return String(hash).replace(/^#/, '') === PRIVACY_NOTICE_HASH;
}

export function privacyNoticeHref() {
  return `#${PRIVACY_NOTICE_HASH}`;
}

function subscribe(onChange) {
  window.addEventListener('hashchange', onChange);
  return () => window.removeEventListener('hashchange', onChange);
}

const readHash = () => (typeof window === 'undefined' ? '' : window.location.hash);

/** Le hash courant, réévalué à chaque navigation interne. */
export function useLocationHash() {
  return useSyncExternalStore(subscribe, readHash, () => '');
}

/**
 * Quitte la politique et revient d'où l'on vient. `history.back()` plutôt
 * qu'un hash vide : le lecteur retrouve la page et la position qu'il avait.
 */
export function useLeaveCookiePolicy() {
  return useCallback(() => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.hash = '';
  }, []);
}
